/**
 * Get the english locale based on the browser language
 * @returns locale string in the format "en-US"
 */
export function enLocale() {
  const language = navigator.language
  if (!language.includes("-")) {
    return "en-US" // default to 'en-US' if no region is specified
  }

  const [_, ...rest] = language.split("-")
  return ["en", ...rest].join("-")
}
